import mode from './../mode';
import SessionStorageService from '../../services/sessionStorage/sessionStorageService';
import {createApiPath, createFetchAndCall, cleanWhitespace} from '../fetch/fetchServices';
import {basicAuthEncoder} from '../../services/authentication/basicAuthEncoder';
import * as constants from '../../constants/storageConstants';
import * as apiConstants from '../../constants/apiConstants';
import docCookies from '../../services/cookieStorage/cookieStorage';

class Login {

  static logout(user) {
    SessionStorageService.deleteItem(constants.credentials);
    SessionStorageService.deleteItem(constants.lastLogin);
    const cookieName = SessionStorageService.getItem(constants.cookieName);
    docCookies.removeItem(cookieName, '/');
    basicAuthEncoder(user);
    window.location.href = apiConstants.samlLogoutApi;
  }

  static login(credentials) {
    if (mode.staticAPI) {
      return this.fakeLogin(credentials);
    } else {
      return this.realLogin(credentials);
    }
  }

  static realLoginWithLoginGov(){
    let loginApi = createApiPath(apiConstants.validateLoggedInUserApi);
    let options = {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    };
    return createFetchAndCall(loginApi, options);
  }

  static realLogin(credentials) {
    credentials.email = cleanWhitespace(credentials.email);
    this.saveCredentials(credentials);
    let loginApi = createApiPath(apiConstants.loginApi);
    let options = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username: credentials.email,
        password: credentials.password,
        googleCaptcha: credentials.googleCaptcha
      })
    };
    return createFetchAndCall(loginApi, options);
  }

  static fakeLogin(credentials) {
    return new Promise((resolve, reject) => {
      //we would probably do something here that wouldn't be logging
      //credentials to console
      SessionStorageService.saveItem(constants.credentials,
        credentials.email + credentials.password);

      const account =
      {
        "user": {
          "userId": "10",
          "userName": "bcoume89",
          "lastLogin": "1469451918",
          "userRoles": ["authenticated", "ita_user"],
          "sessionId": "xxFsiH4YfvDmhvBAog9GTTx425XKC2MNItX0pIh68fU",
          "sessionName": "SESS1c22b1375c7fd4b8e9228dd90f4d3046",
          "csrfToken": "S59NsbRvLG3ErcmHmrFxiTG92DCLI4JUUJ1Vg4drqnc"
        }
      };

      if (mode.loginSucceeds) {
        setTimeout(() => {
          resolve(account);
        }, 1000);
      } else {
        setTimeout(() => {
          reject("Login failed");
        }, 1000);
      }
    });
  }

  static saveCredentials(credentials) {
    credentials = JSON.stringify(credentials);
    SessionStorageService.saveItem(constants.credentials,
      credentials);
  }

  static getCredentials() {
    return JSON.parse(SessionStorageService.getItem(constants.credentials));
  }
}

export default Login;



/** WEBPACK FOOTER **
 ** ./src/api/authentication/loginApi.js
 **/